"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var I18N = {
  PRIVACY_POLICY: 'Privacy Policy',
  TRUST_PAGE: 'Trust Page',
  TERMS: 'Terms'
};
var _default = I18N;
exports["default"] = _default;